import { useEffect, useState } from 'react';
import { IsNullOrEmpty, ParseDate } from '../../../core/utility';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/tr';
import createTheme from '@mui/material/styles/createTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { trTR } from '@mui/x-date-pickers/locales';
import { CommonInputProps } from '../Models';

const theme = createTheme({
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '15px',
                    transform: 'translate(14px, 11px) scale(1)',
                    '&.Mui-focused': {
                        transform: 'translate(14px, -9px) scale(0.85)',
                    },
                    '&.MuiFormLabel-filled': {
                        transform: 'translate(14px, -9px) scale(0.85)',
                    }
                },
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    height: '23px',
                    fontSize: '15px',
                }
            },
        },
    },
});

interface DatePickerProps extends CommonInputProps {
    value: any;
    disableFuture?: boolean;
    disablePast?: boolean;
    minDate?: string;
    maxDate?: string;
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
    onChange?: (event: any) => void;
}

const DatePicker = (props: DatePickerProps) => {

    const [value, setValue] = useState<Dayjs | null>(null);

    useEffect(() => {
        let dateValue = props.value;
        if (typeof dateValue === 'string') {
            dateValue = ParseDate(dateValue);
        }
        setValue(dateValue ? dayjs(dateValue) : null);
    }, [props.value])

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="tr"
            localeText={trTR.components.MuiLocalizationProvider.defaultProps.localeText}>
            <ThemeProvider theme={theme}>
                <MuiDatePicker
                    views={['year', 'month', 'day']}
                    label={`${props.caption} ${props.required ? '*' : ''}`}
                    disabled={props.disabled}
                    readOnly={props.readOnly}
                    disableFuture={props.disableFuture}
                    disablePast={props.disablePast}
                    minDate={props.minDate ? dayjs(props.minDate) : undefined}
                    maxDate={props.maxDate ? dayjs(props.maxDate) : undefined}
                    value={value}
                    onChange={value => {
                        setValue(value);
                        if (props.onChange) {
                            props.onChange({
                                target: {
                                    name: props.name,
                                    value: value && value.isValid() ? value.format('DD.MM.YYYY') : null,
                                },
                            });
                        }
                    }}
                    slots={{
                        textField: TextField,
                    }}
                    slotProps={{
                        textField: {
                            id: props.id,
                            name: props.name,
                            size: 'small',
                            fullWidth: true,
                            autoComplete: 'off',
                            error: !IsNullOrEmpty(props.errorText),
                            helperText: props.errorText,
                            inputProps: {
                                placeholder: 'GG.AA.YYYY',
                            },
                        },
                    }}
                />
            </ThemeProvider>
        </LocalizationProvider>
    );
}

export default DatePicker